var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-cards d-flex"},_vm._l((_vm.cardItems),function(cardItem,index){return _c('link-card-item',{key:cardItem.project.name,class:[
      'link-card-item flex-1',
      { 'ml-5': index > 0, 'd-none d-lg-block': index > 3 } ],attrs:{"type":cardItem.type,"tags":cardItem.tags,"project":cardItem.project,"apy":cardItem.apy}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }